import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { config } from '../../config.js'
import { getLegislation } from '../../util/legislation'
import { useAuth } from '../../providers/AuthProvider'
import BodyText, { BoldSpan } from '../styles/Text'
import ConfirmationTemplate from '../common/ConfirmationTemplate'
import { SecondaryButton } from '../common/Button'
import { ErrorMessage } from '../common/UserMessage'
import { getBillDownloadReceipt } from '../../dataClient/apiCalls'
import { buildBillReceiptPdfFileName } from '../../util/billFormatting'
import { handleDownloadResponse } from '../../util/downloadFile'

function FOIConfirmationPaid({ secondaryId, billSecondaryId, billId }) {
  const { authState } = useAuth()
  const legislation = getLegislation()
  const showLogo = !authState.accessToken
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [downloadError, setDownloadError] = useState(false)

  function handleDownloadReceipt() {
    if (!billId) return

    setDownloadLoading(true)
    setDownloadError(false)
    getBillDownloadReceipt(billId)
      .then(response => {
        handleDownloadResponse(response, buildBillReceiptPdfFileName(billSecondaryId ?? secondaryId), 'download')
        setDownloadLoading(false)
      })
      .catch(e => {
        console.error('An error occurred while downloading the receipt', billId, e)
        setDownloadLoading(false)
        setDownloadError(true)
      })
  }

  return (
    <ConfirmationTemplate title={`Payment Complete & ${secondaryId} Submitted`} bodyText={[]} showLogo={showLogo} showContact={config.showContact}>
      <BodyText>
        Your request has been created and you will receive an emailed receipt for your request: <BoldSpan>{secondaryId}</BoldSpan>.
      </BodyText>
      <BodyText>
        Applicable deadlines related to your request as per {legislation.name} will be confirmed by the City via official correspondence to follow.
      </BodyText>
      {billId && (
        <>
          <SecondaryButton onClick={handleDownloadReceipt} loading={downloadLoading}>
            Download Receipt
          </SecondaryButton>
          {downloadError && <ErrorMessage>There was an error downloading your receipt. Please try again.</ErrorMessage>}
        </>
      )}
    </ConfirmationTemplate>
  )
}

FOIConfirmationPaid.propTypes = {
  secondaryId: PropTypes.string.isRequired,
  billSecondaryId: PropTypes.string,
  billId: PropTypes.string
}

export default FOIConfirmationPaid
